import { useSyncExternalStore } from 'react'
import { getLinkingFailure, subscribeLinkingFailure, ILinkingFailure } from '@/utils/activation'

const getServerSnapshot = (): ILinkingFailure | null => null

/**
 * The pending activation linking failure, or null (PRO-15). Written only by
 * `withEntitlement` when an auth response reports `orderLinked: false`;
 * AuthActor renders it as the per-reason modal and gates its post-auth
 * redirect on it. In-memory per page load — see `linkingFailureStore`.
 */
export const useActivationLinkingFailure = (): ILinkingFailure | null =>
  useSyncExternalStore(subscribeLinkingFailure, getLinkingFailure, getServerSnapshot)
